/** Case-insensitive name + email key; matches API `ShareholderService.MatchKey`. */
export const shareholderMatchKey = (name: string, email: string): string =>
  `${(name ?? '').trim().toLowerCase()}|${(email ?? '').trim().toLowerCase()}`;

export const DUPLICATE_SHAREHOLDER_MESSAGE = 'A shareholder with this full name or email already exists.';

export const hasShareholderNameOrEmailConflict = (
  shareholders: { name: string; email: string }[],
  name: string,
  email: string
): boolean => {
  const normalizedName = (name ?? '').trim().toLowerCase();
  const normalizedEmail = (email ?? '').trim().toLowerCase();
  return shareholders.some(
    (s) =>
      (s.name ?? '').trim().toLowerCase() === normalizedName || (s.email ?? '').trim().toLowerCase() === normalizedEmail
  );
};
